import LoadingSpinner from '@/components/LoadingSpinner';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';

const PlaceholderWrapper = styled('div')(
  ({ theme }) => ({
    padding: 24,
    width: 400,
    maxWidth: '100%',
    height: 400,
    maxHeight: '100%',
    backgroundColor: theme.palette.action.hover,
    display: 'flex',
    borderRadius: 4,
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    '.MuiCircularProgress-root': {
      marginBottom: 18,
    },
    p: {
      margin: 0,
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }),
  addHighContrastStyles(({ theme }) => ({
    backgroundColor: theme.isDark ? 'rgba(0, 0, 0, .2)' : 'transparent',
  })),
);

const ImageLoadingPlaceholder = () => (
  <PlaceholderWrapper>
    <LoadingSpinner />
    <p>
      <FormattedMessage id="portfolio.challenge.files.uploaded_image.preview_dialog.image_loading_placeholder.text" />
    </p>
  </PlaceholderWrapper>
);

export default ImageLoadingPlaceholder;
